import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Turns a rejected request into the login screen. This is what catches a session
 * that expired while the tab was open — every guarded endpoint answers 401 then.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // The session endpoint reports "not logged in" as a normal 200 response, and a
  // failing login must show its own error rather than re-trigger the overlay.
  const isAuthEndpoint = req.url.startsWith('/api/auth/');

  return next(req.clone({ withCredentials: true })).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !isAuthEndpoint) {
        auth.markSessionExpired();
      }
      return throwError(() => err);
    }),
  );
};
